/* This file is autogenerated by @oui/cli */
import Svg, { Circle, Path, Rect, type SvgProps } from 'react-native-svg';

const SvgComponent = (props: SvgProps) => (
  <Svg width={18} height={18} viewBox="0 0 18 18" fill="none" {...props}>
    <Rect
      x={1}
      y={1}
      width={16}
      height={16}
      rx={3}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.21 11.4a4.47 4.47 0 0 0-4.24 2.89s1.35-.95 4.24-.95 4.14.95 4.14.95-.86-2.89-4.14-2.89Z"
      fill="currentColor"
    />
    <Circle cx={4.98} cy={6.71} r={0.84} fill="currentColor" stroke="currentColor" />
    <Circle cx={13.01} cy={6.71} r={0.84} fill="currentColor" stroke="currentColor" />
  </Svg>
);
export default SvgComponent;
